import React, { useCallback } from 'react';
import HideIcon from '@uber/base-icons/hide';
import ShowIcon from '@uber/base-icons/show';
import { Button, KIND, SHAPE, SIZE } from 'baseui/button';
import { SHOW_HIDE_ICON_SIZE } from '../../constant/constant';
type PropsT = {
  hidden: boolean;
  onClick: (hidden: boolean) => void;
  disabled?: boolean;
};
export const ShowHideButton = ({
  hidden,
  onClick,
  disabled
}: PropsT) => {
  const handleOnShowHideClick = useCallback(e => {
    e.stopPropagation();
    onClick(!hidden);
  }, [hidden, onClick]);
  return <Button size={SIZE.mini} onClick={handleOnShowHideClick} shape={SHAPE.circle} kind={KIND.tertiary} disabled={disabled}>
      {hidden ? <HideIcon title="Show annotation" size={SHOW_HIDE_ICON_SIZE} /> : <ShowIcon title="Hide annotation" size={SHOW_HIDE_ICON_SIZE} />}
    </Button>;
};
export default ShowHideButton;